import { Component } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass']
})
export class AppComponent {
  logo: string;

  constructor(private router: Router) {
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        switch (event.url) {
          case "/":
            this.logo = 'home';
            break;
          case "/skills":
            this.logo = 'flash_on';
            break;
          case "/portfolio":
            this.logo = 'work';
            break;
          case "/studies":
            this.logo = 'school';
            break;
          default:
            break;
        }
      }
    });
  }
}
